import React from 'react';
import Asterisk from '../../shared/components/Asterisk';
import CheckboxField from '../../shared/components/CheckboxField';

/**
 * @typedef {object} WillingToTravelFieldsProps
 * @property {Object} [appraiserData]
 * @property {(name: string, checked: boolean) => void} [setValue]
 */

/**
 * @param {WillingToTravelFieldsProps} props
 */
const WillingToTravelFields = props => {
  const { setValue, appraiserData = {} } = props;

  return (
    <>
      <h4 className='field-title' data-testid='field-title-willing-to-travel'>
        Willingness to travel
        <Asterisk />
      </h4>
      <CheckboxField
        title='Africa'
        name='willingToTravelToAfrica'
        checked={appraiserData.willingToTravelToAfrica}
        handleChange={setValue}
      />
      <CheckboxField
        title='Asia'
        name='willingToTravelToAsia'
        checked={appraiserData.willingToTravelToAsia}
        handleChange={setValue}
      />
      <CheckboxField
        title='Australia'
        name='willingToTravelToAustralia'
        checked={appraiserData.willingToTravelToAustralia}
        handleChange={setValue}
      />
      <CheckboxField
        title='Europe'
        name='willingToTravelToEurope'
        checked={appraiserData.willingToTravelToEurope}
        handleChange={setValue}
      />
      <CheckboxField
        title='North America'
        name='willingToTravelToNorthAmerica'
        checked={appraiserData.willingToTravelToNorthAmerica}
        handleChange={setValue}
      />
      <CheckboxField
        title='South America'
        name='willingToTravelToSouthAmerica'
        checked={appraiserData.willingToTravelToSouthAmerica}
        handleChange={setValue}
      />
      <CheckboxField
        title='Virtual'
        name='willingToTravelToVirtual'
        checked={appraiserData.willingToTravelToVirtual}
        handleChange={setValue}
      />
    </>
  );
};

export default WillingToTravelFields;
